'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Core = require('../Core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Representation of an Oauth connection
 *
 * @class
 */
var OauthConnection = function (_PropertyBag) {
  (0, _inherits3.default)(OauthConnection, _PropertyBag);
  (0, _createClass3.default)(OauthConnection, null, [{
    key: 'fromJS',

    /**
     * @static
     * @method
     *
     * @param {{}} js
     * @return {OauthConnection}
     */
    value: function fromJS(js) {
      var providerName = js.providerName,
          urlAuthorize = js.urlAuthorize,
          urlAccessToken = js.urlAccessToken,
          urlResourceOwnerDetails = js.urlResourceOwnerDetails,
          urlRedirect = js.urlRedirect,
          clientId = js.clientId,
          clientSecret = js.clientSecret,
          otherProps = (0, _objectWithoutProperties3.default)(js, ['providerName', 'urlAuthorize', 'urlAccessToken', 'urlResourceOwnerDetails', 'urlRedirect', 'clientId', 'clientSecret']);

      return new OauthConnection((0, _extends3.default)({ providerName: providerName, urlAuthorize: urlAuthorize, urlAccessToken: urlAccessToken, urlResourceOwnerDetails: urlResourceOwnerDetails, urlRedirect: urlRedirect, clientId: clientId, clientSecret: clientSecret }, otherProps));
    }

    /**
     * @param {String} providerName the provider name
     * @param {String} urlAuthorize the url of the authorize endpoint
     * @param {String} urlAccessToken the url of the token endpoint
     * @param {String} [urlResourceOwnerDetails] the url of an endpoint that can be used after a token is obtained to retrieve information about the user
     * @param {String} urlRedirect the url the oauth provider will redirect the browser after the user grants access
     * @param {String} clientId the id of the client registered with the oauth provider
     * @param {String} [clientSecret] an optional client secret
     * @param {...*} [otherProps]
     */

  }]);

  function OauthConnection(_ref) {
    var providerName = _ref.providerName,
        urlAuthorize = _ref.urlAuthorize,
        urlAccessToken = _ref.urlAccessToken,
        urlResourceOwnerDetails = _ref.urlResourceOwnerDetails,
        urlRedirect = _ref.urlRedirect,
        clientId = _ref.clientId,
        clientSecret = _ref.clientSecret,
        otherProps = (0, _objectWithoutProperties3.default)(_ref, ['providerName', 'urlAuthorize', 'urlAccessToken', 'urlResourceOwnerDetails', 'urlRedirect', 'clientId', 'clientSecret']);
    (0, _classCallCheck3.default)(this, OauthConnection);
    return (0, _possibleConstructorReturn3.default)(this, (OauthConnection.__proto__ || (0, _getPrototypeOf2.default)(OauthConnection)).call(this, (0, _extends3.default)({ providerName: providerName, urlAuthorize: urlAuthorize, urlAccessToken: urlAccessToken, urlResourceOwnerDetails: urlResourceOwnerDetails, urlRedirect: urlRedirect, clientId: clientId, clientSecret: clientSecret }, otherProps)));
  }

  /**
   * @readonly
   * @type {*|String}
   */


  (0, _createClass3.default)(OauthConnection, [{
    key: 'providerName',
    get: function get() {
      return this.props.providerName;
    }

    /**
     * @readonly
     * @type {String}
     */

  }, {
    key: 'urlAuthorize',
    get: function get() {
      return this.props.urlAuthorize;
    }

    /**
     * @readonly
     * @type {String}
     */

  }, {
    key: 'urlAccessToken',
    get: function get() {
      return this.props.urlAccessToken;
    }

    /**
     * @readonly
     * @type {null|String}
     */

  }, {
    key: 'urlResourceOwnerDetails',
    get: function get() {
      return this.props.urlResourceOwnerDetails;
    }

    /**
     * @readonly
     * @type {null|String}
     */

  }, {
    key: 'urlRedirect',
    get: function get() {
      return this.props.urlRedirect;
    }

    /**
     * @readonly
     * @type {String}
     */

  }, {
    key: 'clientId',
    get: function get() {
      return this.props.clientId;
    }

    /**
     * @readonly
     * @type {null|String}
     */

  }, {
    key: 'clientSecret',
    get: function get() {
      return this.props.clientSecret;
    }
  }]);
  return OauthConnection;
}(_Core.PropertyBag);

exports.default = OauthConnection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Security/OauthConnection.js
// module id = 317
// module chunks = 0